import { useContext } from 'react';

import { QConfigStructureContext } from './qconfig-structure-modal-provider';

function useQConfigStructureModal() {
  const context = useContext(QConfigStructureContext);

  if (!context) {
    throw new Error('useQConfigStructureModal must be used within a QConfigStructureModalProvider');
  }

  return context;
}

export { useQConfigStructureModal };
